

































import { Component, Prop, Vue } from 'vue-property-decorator';
import Magazine from '@/models/Magazine';
import { namespace } from 'vuex-class';
import Bookmark from '@/models/Bookmark';

const MagazineStore = namespace('magazine');
const BookmarkStore = namespace('bookmark');
const ApplicationStore = namespace('application');

@Component({})
export default class MagazineCellComponent extends Vue {

    @Prop({ default: new Magazine() })
    private magazine!: Magazine;

    @MagazineStore.Mutation('setSelectedMagazine')
    private setSelectedMagazine!: (magazine: Magazine) => void;

    @MagazineStore.Action('getMagazineCover')
    private getMagazineCoverAction!: (payload: { coverUrl: string }) => string;

    @BookmarkStore.Getter('getBookmarkById')
    private getBookmarkById!: (id: string) => Bookmark | undefined;

    @ApplicationStore.Getter('noAnimations')
    public noAnimations!: boolean;

    @BookmarkStore.Mutation('setActiveBookmark')
    private setActiveBookmark!: (bookmark: Bookmark) => void;

    public animationDelay: boolean = false;
    public ANIMATION_DELAY_VALUE: number = 1800;

    private XXXS_BREAKPOINT: number = 380;
    private XXS_BREAKPOINT: number = 420;

    private MAX_MAGAZINE_NAME_LENGTH: number = 38;

    /**
     * Determines the height of covers
     */
    get coverHeight(): number {
        // xxx-xs
        let value = 150;
        // xx-xs
        if (this.$vuetify.breakpoint.width > this.XXXS_BREAKPOINT) {
            value = 180;
            // x-xs
        } else if (this.$vuetify.breakpoint.width > this.XXS_BREAKPOINT) {
            value = 220;
        }
        return value;
    }

    /**
     * Determines the width of covers
     */
    get coverWidth(): number {
        // xxx-xs
        let value = 120;
        // xx-xs
        if (this.$vuetify.breakpoint.width > this.XXXS_BREAKPOINT) {
            value = 150;
            // x-xs
        } else if (this.$vuetify.breakpoint.width > this.XXS_BREAKPOINT) {
            value = 180;
        }
        return value;
    }

    public async mounted() {
        // Quick and dirty solution
        // I think the same result can be achieved with vue transitions
        // https://css-tricks.com/intro-to-vue-5-animations/
        if (!this.noAnimations) {
            const delay = Math.random() * this.ANIMATION_DELAY_VALUE;
            setTimeout(() => {
                this.animationDelay = true;
            }, delay);
        }
    }

    /**
     * Prepares magazines name if it exceeds a distinct length
     * @param name
     */
    public prepareMagazineName(name: string) {
        if (name.length > this.MAX_MAGAZINE_NAME_LENGTH) {
            return `${name.slice(0, this.MAX_MAGAZINE_NAME_LENGTH)}...`;
        } else {
            return name;
        }

    }

    public openMagazine(magazine: Magazine) {

        // Only show the covers in the show room mode and don't open the reader
        if (process.env.VUE_APP_SHOW_ROOM_MODE === 'true') {
            this.$notifyInfoSimplified('LIBRARY.SHOW_ROOM_MODE', null, 10000);
            return;
        }

        this.setSelectedMagazine(magazine);

        const bookmark = this.getBookmarkById(magazine.publicationId);
        this.setActiveBookmark(bookmark!);

        this.$router.push({ name: 'reader_view' });
    }

    get hasBookmark(): boolean {
        return this.getBookmarkById(this.magazine.publicationId) !== undefined;
    }
};
